module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="center">Merge to <a href="/#person/'+
((__t=( mergeToPersonId ))==null?'':__t)+
'" target="_blank">'+
((__t=( mergeToPersonName ))==null?'':__t)+
'</a></h4>\r\n\r\n<table class="table table-hover well">\r\n    <thead>\r\n    <tr>\r\n        <th>Type</th>\r\n        <th>Code</th>\r\n        <th>Name</th>\r\n        <th>Start date</th>\r\n        <th>Stop date</th>\r\n        <th>Comment</th>\r\n        <th title="Exacerbations">Exac.</th>\r\n        <th></th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    ';
 _.each(diseases, function(disease, index) { 
__p+='\r\n\r\n    <tr ';
 if (!isMergedDisease(disease)) { 
__p+=' class="deprecated-header" ';
 } 
__p+=' >\r\n        <td>'+
((__t=( getTypeOfIdName(disease.typeOfId) ))==null?'':__t)+
'</td>\r\n        <td>'+
((__t=( disease.diseaseId ))==null?'':__t)+
'</td>\r\n        <td>'+
((__t=( disease.name ))==null?'':__t)+
'</td>\r\n        <td>'+
((__t=( formatDate(disease.startDate) ))==null?'':__t)+
'</td>\r\n        <td>'+
((__t=( formatDate(disease.stopDate) ))==null?'':__t)+
'</td>\r\n        <td class="center"><span class="clickable center show-comment" id="'+
((__t=( disease.uuid + '__' ))==null?'':__t)+
'" title="Show comment">...</span></td>\r\n        <td class="center"><span class="clickable center show-exacs" id="'+
((__t=( disease.uuid + '_' ))==null?'':__t)+
'" title="Show exacerbations">...</span></td>\r\n        <td><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
((__t=( disease.uuid ))==null?'':__t)+
'" title="Remove"></span></td>\r\n    </tr>\r\n\r\n    ';
 }) 
__p+='\r\n    </tbody>\r\n</table>\r\n\r\n<!-- Exacerbation show modal -->\r\n<div class="modal fade" id="exacerbation-show-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">Exacerbations</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="exacerbation-show"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" id="close" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n<div id="comment-content"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/merge-to-person-diseases-view.html
// module id = 489
// module chunks = 0